import { Controller, useFormContext } from "react-hook-form";
import { ErrorMessage, Icon, Toggle, Tooltip, Typography } from "@/components/atoms";
import { clsx } from "@/utils";
import { TimeAndDayFormData } from "../../types";

export const TreatAsSpecialEventField = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  const {
    control,
    formState: { errors },
  } = useFormContext<TimeAndDayFormData>();

  return (
    <div className={clsx("flex flex-col gap-y-1", className)} {...props}>
      <div className="flex flex-row items-center gap-2">
        <Typography variant="action">Treat as Special Event</Typography>
        <Tooltip
          content={
            <Typography variant="action">
              Enabling this multiplier treats jobs as special events with the applicable cancellation policy. Clients must contact you for
              changes or cancellations
            </Typography>
          }
          placement="right"
        >
          <Icon name="InfoCircle" variant="Bold" className="rotate-180 text-neutral-dark-gray" size="lg" />
        </Tooltip>
      </div>
      <Controller
        name="treatAsSpecialEvent"
        control={control}
        render={({ field }) => (
          <div className="flex flex-row items-center gap-x-4">
            <Toggle checked={field.value} onChange={(checked) => field.onChange(checked)} />
            <Typography className="inline">{field.value ? "Yes" : "No"}</Typography>
          </div>
        )}
      />
      <ErrorMessage errors={errors} name="treatAsSpecialEvent" />
    </div>
  );
};
